import { useState } from 'react';

import { Button, ButtonsGrid } from 'components/common/button/button';
import { fungibleTokensService } from 'services/fungible-tokens';
import { useAppDispatch, useAppSelector } from 'redux/use-hooks';
import { actionAccountSetStorageBalance, selectAccountId } from 'redux/slices/account';
import { getWalletActionErrorPresentation } from 'utils/wallet';

import { getMethodNameFromTextButton } from './utils';

import { actions as statusSliceActions } from 'redux/slices/status';
const { showCustomAlert } = statusSliceActions;

import { actions as tokensSliceActions } from 'redux/slices/tokens';
const { fetchTokens, fetchPlantTokens } = tokensSliceActions;

import config from 'config';
const { OPN_CONTRACT, OCC_CONTRACT } = config;

import {
  StyledContainer,
  StyledSection,
  StyledHeading,
  StyledSemi
} from './views.style';

const PlantView = ({
  text,
  closeModal,
  selected,
  callback
}: {
  text: string;
  closeModal: () => void;
  selected: string[];
  callback: (s) => void;
}) => {
  const dispatch = useAppDispatch();
  const accountId = useAppSelector(selectAccountId);
  const [sendingToken, setSendingToken] = useState(false);
  const methodName = getMethodNameFromTextButton(text);
  const onClickHandler = async () => {
    setSendingToken(true);
    try {
      await fungibleTokensService.plant({
        accountId,
        contractName: OPN_CONTRACT,
        methodName,
        amount: selected[0]
      });
      await dispatch(fetchTokens({ accountId }));
      await dispatch(fetchPlantTokens({ accountId }));
      dispatch(actionAccountSetStorageBalance({ contractName: OCC_CONTRACT, accountId }));
      setSendingToken(false);
      callback(true);
      closeModal();
    } catch (e: any) {
      const presentation = getWalletActionErrorPresentation(e);
      console.error('plantTransactionError', {
        error: e,
        kind: presentation.kind,
        message: presentation.messageCode,
        failure: e?.failure || null
      });
      dispatch(
        showCustomAlert({
          showAlert: true,
          success: false,
          messageCodeHeader: 'error',
          messageCode: presentation.messageCode,
          errorMessage: presentation.errorMessage
        })
      );
      setSendingToken(false);
    }
  };

  return (
    <StyledContainer>
      <StyledSection p="80px 100px">
        <StyledHeading mb="48px">
          Are you sure you want to <br />
          {text && <StyledSemi>{text}?</StyledSemi>}
        </StyledHeading>
        <ButtonsGrid>
          <Button
            fullwidth
            loading={sendingToken}
            disabled={sendingToken}
            onClick={onClickHandler}
          >
            Yes
          </Button>
          <Button fullwidth variant="secondary" onClick={closeModal}>
            No
          </Button>
        </ButtonsGrid>
      </StyledSection>
    </StyledContainer>
  );
};

export default PlantView;
